export enum PaymentStates {
  SUCCESSFUL = 'SUCCESSFUL',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  PROCESSING = 'PROCESSING',
  FORCE_FAILED = 'FORCE_FAILED',
  FORCE_SUCCESSFUL = 'FORCE_SUCCESSFUL',
}

export enum PaymentTypes {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
}

export interface PaymentAttribute {
  transactionId: string;
  state: PaymentStates;
}
